import { RegisterMultiorg } from './RegisterMultiorg'

export const RegisterMultiorgPage = () => {
  return <RegisterMultiorg />
}

export default RegisterMultiorgPage
